import React from 'react';
import { Helmet } from 'react-helmet';

const DEFAULT_FAVICON =
  'https://res.cloudinary.com/joegalaxy/image/upload/v1656195322/Images/favicon_urfztm.ico';

const getFaviconType = (favicon) => {
  const href = String(favicon || '').toLowerCase().split('?')[0];
  if (href.endsWith('.ico')) return 'image/x-icon';
  if (href.endsWith('.png')) return 'image/png';
  return undefined;
};

const GenericHelmet = ({
  title,
  description,
  image,
  url,
  regionName,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  twitterTitle,
  twitterDescription,
  twitterImage,
  favicon = DEFAULT_FAVICON,
  jsonLd,
}) => {
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDescription = ogDescription || description;
  const resolvedOgImage = ogImage || image;
  const resolvedOgUrl = ogUrl || url;
  const resolvedTwitterTitle = twitterTitle || resolvedOgTitle;
  const resolvedTwitterDescription =
    twitterDescription || resolvedOgDescription;
  const resolvedTwitterImage = twitterImage || resolvedOgImage;
  const faviconType = getFaviconType(favicon);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {favicon && (
        <link
          rel="icon"
          {...(faviconType ? { type: faviconType } : {})}
          href={favicon}
        />
      )}
      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDescription} />
      {resolvedOgImage && <meta property="og:image" content={resolvedOgImage} />}
      <meta property="og:type" content={ogType} />
      {resolvedOgUrl && <meta property="og:url" content={resolvedOgUrl} />}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={resolvedTwitterTitle} />
      <meta name="twitter:description" content={resolvedTwitterDescription} />
      {resolvedTwitterImage && (
        <meta name="twitter:image" content={resolvedTwitterImage} />
      )}
      {regionName && <meta name="region" content={regionName} />}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default GenericHelmet;
